// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatInputController from "./chat_input_controller"
application.register("chat-input", ChatInputController)

import ChatPanelController from "./chat_panel_controller"
application.register("chat-panel", ChatPanelController)

import ChatStreamingController from "./chat_streaming_controller"
application.register("chat-streaming", ChatStreamingController)

import DashboardFiltersController from "./dashboard_filters_controller"
application.register("dashboard-filters", DashboardFiltersController)

import DateNavigatorController from "./date_navigator_controller"
application.register("date-navigator", DateNavigatorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import Management__AnalyticsChartController from "./management/analytics_chart_controller"
application.register("management--analytics-chart", Management__AnalyticsChartController)

import Management__FunnelChartController from "./management/funnel_chart_controller"
application.register("management--funnel-chart", Management__FunnelChartController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import TimezoneDetectionController from "./timezone_detection_controller"
application.register("timezone-detection", TimezoneDetectionController)

import TimezoneFillerController from "./timezone_filler_controller"
application.register("timezone-filler", TimezoneFillerController)

import ViewTransitionController from "./view_transition_controller"
application.register("view-transition", ViewTransitionController)
